"use strict";

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.calculatePosition = void 0;
var domHelpers = __importStar(require("../../util/dom-helpers"));
var owner_document_1 = require("./owner-document");
function getContainerDimensions(containerNode) {
  var _a;
  var width;
  var height;
  var scroll;
  if (containerNode.tagName === 'BODY') {
    width = window.innerWidth;
    height = window.innerHeight;
    scroll = domHelpers.getScrollTop(owner_document_1.ownerDocument(containerNode).documentElement) || domHelpers.getScrollTop(containerNode);
  } else {
    _a = domHelpers.offset(containerNode), width = _a.width, height = _a.height;
    scroll = domHelpers.getScrollTop(containerNode);
  }
  return {
    width: width,
    height: height,
    scroll: scroll
  };
}
function getTopDelta(top, overlayHeight, container, padding) {
  var containerDimensions = getContainerDimensions(container);
  var containerScroll = containerDimensions.scroll;
  var containerHeight = containerDimensions.height;
  var topEdgeOffset = top - padding - containerScroll;
  var bottomEdgeOffset = top + padding - containerScroll + overlayHeight;
  if (topEdgeOffset < 0) {
    return -topEdgeOffset;
  } else if (bottomEdgeOffset > containerHeight) {
    return containerHeight - bottomEdgeOffset;
  } else {
    return 0;
  }
}
function getLeftDelta(left, overlayWidth, container, padding) {
  var containerDimensions = getContainerDimensions(container);
  var containerWidth = containerDimensions.width;
  var leftEdgeOffset = left - padding;
  var rightEdgeOffset = left + padding + overlayWidth;
  if (leftEdgeOffset < 0) {
    return -leftEdgeOffset;
  } else if (rightEdgeOffset > containerWidth) {
    return containerWidth - rightEdgeOffset;
  }
  return 0;
}
function calculatePosition(placement, overlayNode, target, container, padding) {
  var childOffset = container.tagName === 'BODY' ? domHelpers.offset(target) : domHelpers.position(target, container);
  var _a = domHelpers.offset(overlayNode),
    overlayHeight = _a.height,
    overlayWidth = _a.width;
  var positionLeft;
  var positionTop;
  var arrowOffsetLeft;
  var arrowOffsetTop;
  var overlayPadding = 0;
  if (placement === 'left' || placement === 'right') {
    positionTop = childOffset.top + (childOffset.height - overlayHeight) / 2;
    if (placement === 'left') {
      positionLeft = childOffset.left - overlayWidth;
    } else {
      positionLeft = childOffset.left + childOffset.width;
    }
    var topDelta = getTopDelta(positionTop, overlayHeight, container, padding);
    positionTop = positionTop + topDelta;
    // Arrow is aligning with respect to popover content. Consider overlay padding(top, bottom) to get exact popover content height.
    overlayPadding = (parseInt(domHelpers.getCss(overlayNode, 'padding-top'), 10) || 0) + (parseInt(domHelpers.getCss(overlayNode, 'padding-bottom'), 10) || 0);
    arrowOffsetTop = 50 * (1 - 2 * topDelta / (overlayHeight - overlayPadding)) + '%';
    arrowOffsetLeft = void 0;
  } else if (placement === 'top' || placement === 'bottom') {
    positionLeft = childOffset.left + (childOffset.width - overlayWidth) / 2;
    if (placement === 'top') {
      positionTop = childOffset.top - overlayHeight;
    } else {
      positionTop = childOffset.top + childOffset.height;
    }
    var leftDelta = getLeftDelta(positionLeft, overlayWidth, container, padding);
    positionLeft = positionLeft + leftDelta;
    // Arrow is aligning with respect to popover content. Consider overlay padding(left, right) to get exact popover content width.
    overlayPadding = (parseInt(domHelpers.getCss(overlayNode, 'padding-left'), 10) || 0) + (parseInt(domHelpers.getCss(overlayNode, 'padding-right'), 10) || 0);
    arrowOffsetLeft = 50 * (1 - 2 * leftDelta / (overlayWidth - overlayPadding)) + '%';
    arrowOffsetTop = void 0;
  } else {
    throw new Error("calcOverlayPosition(): No such placement of \"" + placement + "\" found.");
  }
  return {
    positionLeft: positionLeft,
    positionTop: positionTop,
    arrowOffsetLeft: arrowOffsetLeft,
    arrowOffsetTop: arrowOffsetTop
  };
}
exports.calculatePosition = calculatePosition;